import React, { PropsWithChildren } from "react";
import "./Modal.css";
import AttentionIcon from "../../svg/Attention";

interface IModalProps {
  active: boolean;
  isConfirming: boolean;
  title: string;
  onExecute: () => void;
  onClose: () => void;
}

const Modal = ({
  active,
  title,
  onClose,
  isConfirming,
  children,
  onExecute,
}: PropsWithChildren<IModalProps>) => {
  if (!active) {
    return null;
  }

  return (
    <div className="modal" onClick={onClose}>
      <div
        className="modal__content"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal__header">
          <AttentionIcon color="#1c1c1c" />

          <div className="modal__title">{title}</div>
        </div>
        <div className="modal__body">{children}</div>
        <div className="modal__footer">
          {isConfirming ? (
            <>
              <button className="modal__button" onClick={onExecute}>
                Подтвердить
              </button>
              <button className="cancel__button" onClick={onClose}>
                Отменить
              </button>
            </>
          ) : (
            <button className="modal__button" onClick={onClose}>
              Закрыть
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Modal);
